import styled from "styled-components";
import theme from "../../../styles/theme";

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1.5vh;
  width: 100%;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: ${theme.fontSize.mm};
  color: ${theme.colors.brown.primary};
  margin-bottom: 0.5vh;

  .label-text {
    margin-left: 8px;
  }
`;

export const RadioInput = styled.input`
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid ${theme.colors.brown.primary};
  border-radius: 50%;
  transition: background-color 0.3s ease;

  &:checked {
    background-color: ${theme.colors.brown.primary};
    border-color: ${theme.colors.brown.capivara};
  }

  &:focus {
    outline: 2px solid ${theme.colors.brown.primary};
  }
`;

export const Description = styled.p`
  font-size: ${theme.fontSize.sm};
  color: ${theme.colors.palete.brownDark};
  margin-left: 24px;
  margin-top: 0;
`;
